import { useState } from 'react';
import styled from 'styled-components';
import {
  ButtonTertiary,
  IconHelpCircle,
  Popover,
  PopoverTrigger,
  Type,
} from '@spotify-internal/encore-web';
import { useApprovalStatusCopy } from '@hooks/useApprovalStatusCopy';

const StyledPopover = styled(Popover)`
  max-width: 380px;
  width: 380px;
`;

const PopoverContent = styled.div`
  padding: 8px 0;
`;

const StatusEntry = styled.div`
  margin-bottom: 16px;
  &:last-child {
    margin-bottom: 0;
  }
`;

export const ApprovalStatusInfoPopover = () => {
  const copy = useApprovalStatusCopy();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <PopoverTrigger
      placement="bottomStart"
      withPortal
      hideCloseButton
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
      overlay={
        isOpen && (
          <StyledPopover arrow="topEnd" aria-label={copy.columnHeader}>
            <PopoverContent>
              <StatusEntry>
                <Type as="p" variant="mestoBold">
                  {copy.approved}
                </Type>
                <Type as="p" variant="mesto">
                  {copy.approvedDescription}
                </Type>
              </StatusEntry>
              <StatusEntry>
                <Type as="p" variant="mestoBold">
                  {copy.declined}
                </Type>
                <Type as="p" variant="mesto">
                  {copy.declinedDescription}
                </Type>
              </StatusEntry>
              <StatusEntry>
                <Type as="p" variant="mestoBold">
                  {copy.partiallyApproved}
                </Type>
                <Type as="p" variant="mesto">
                  {copy.partiallyApprovedDescription}
                </Type>
              </StatusEntry>
              <StatusEntry>
                <Type as="p" variant="mestoBold">
                  {copy.needsApproval}
                </Type>
                <Type as="p" variant="mesto">
                  {copy.needsApprovalDescription}
                </Type>
              </StatusEntry>
              <StatusEntry>
                <Type as="p" variant="mestoBold">
                  {copy.expired}
                </Type>
                <Type as="p" variant="mesto">
                  {copy.expiredDescription}
                </Type>
              </StatusEntry>
              <StatusEntry>
                <Type as="p" variant="mestoBold">
                  {copy.noApprovalNeeded}
                </Type>
                <Type as="p" variant="mesto">
                  {copy.noApprovalNeededDescription}
                </Type>
              </StatusEntry>
            </PopoverContent>
          </StyledPopover>
        )
      }
    >
      <ButtonTertiary
        condensedAll
        buttonSize="sm"
        iconOnly={() => <IconHelpCircle iconSize={16} />}
        aria-label={copy.infoButtonLabel}
        aria-expanded={isOpen}
      />
    </PopoverTrigger>
  );
};
